// STYLES
import * as Style from "./SelectAtomStyle";

// LIBRARIES
import { SelectChangeEvent } from "@mui/material/Select";
import { MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "./SelectAtomModel";

// ASSETS
import { ReactComponent as Arrow } from "assets/Icons/Arrow Left.svg";



// REDUX

// COMPONENTS

const SelectAtom = (props: IProps) => {
  // PROPS
  const {
    hasLabel = true,
    label = "",
    options,
    setSelectedOptions = () => {},
    selectedOptions = "",
  } = props;

  // CONSTANTS USING LIBRARIES
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleChange = (event: SelectChangeEvent) => {
    setSelectedOptions(event.target.value);
  };

  return (
    <Style.SelectAtomContainer>
      {/* {hasLabel && <Style.LabelContainer>{label}</Style.LabelContainer>} */}
      <Style.FormControlContainer>
        <Style.SelectContainer
          selectedOptions={selectedOptions}
          value={selectedOptions}
          size="small"
          onChange={handleChange}
          displayEmpty
          IconComponent={Arrow}
        >
          {selectedOptions === "" && (
            <MenuItem value="" disabled>
              {t("atom.selectAtom.placeholder.select")}
            </MenuItem>
          )}
          {options &&
            options.map((option) => {
              return (
                <MenuItem divider={true} value={option.key} key={option.value}>
                  {option.value}
                </MenuItem>
              );
            })}
        </Style.SelectContainer>
      </Style.FormControlContainer>
    </Style.SelectAtomContainer>
  );
};

export default SelectAtom;
